<template>
  <vs-row vs-justify="center" id="Forms-box">
    <vs-col type="flex" vs-lg="12" vs-xs="12">
      <vs-card id="form" fixedHeight>
        <div slot="header">
          <vs-row>
            <vs-col>
              <h3>
                {{ $t("Forms.RDV.Title") }}
              </h3>
            </vs-col>
            <vs-col vs-lg="3">
              <vs-button
                class="w-100"
                id="add-Booking-Field-form"
                icon="add"
                color="primary"
                @click="activeCreateInv = true"
                >{{ $t("Forms.RDV.CreateTitle") }}</vs-button
              >
            </vs-col>
            <vs-col vs-lg="3">
              <vs-button
                class="w-100"
                id="add-Booking-Field-form"
                icon="add"
                color="primary"
                @click="$router.push('/settings/survey-result')"
                >{{ $t("Forms.SurveyResult") }}</vs-button
              >
            </vs-col>
          </vs-row>
        </div>

        <vs-table
          :data="investigations"
          @selected="handleSelected"
          id="investigat-box"
          max-items="10"
        >
          <template slot="thead">
            <vs-th sort-key="id">{{ $t("Forms.RDV.Id") }}</vs-th>
            <vs-th sort-key="status">{{ $t("Forms.RDV.Status") }}</vs-th>
            <vs-th sort-key="number">{{ $t("Forms.RDV.StepRow") }}</vs-th>
            <vs-th sort-key="question">{{ $t("Forms.RDV.Question") }}</vs-th>
            <vs-th sort-key="options">{{ $t("Forms.RDV.Options") }}</vs-th>
          </template>

          <template slot-scope="{ data }">
            <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
              <vs-td :data="data[indextr].type">
                <div class="d-flex align-items-center">
                  <h5 class="mb-0 font-12">{{ data[indextr].id }}</h5>
                </div>
              </vs-td>

              <vs-td :data="data[indextr].status">
                <div class="d-flex align-items-center">
                  <vs-switch
                    color="success"
                    v-model="data[indextr].status"
                    @input="
                      approvedPromptInv(data[indextr].status, data[indextr].id)
                    "
                  >
                    <!--updateApproval(data[indextr].approved,data[indextr].id) -->
                  </vs-switch>
                </div>
              </vs-td>

              <vs-td :data="data[indextr].questions.length">
                <div class="d-flex align-items-center">
                  <h5 class="mb-0 font-12">
                    {{ data[indextr].questions.length }}
                  </h5>
                </div>
              </vs-td>

              <vs-td :data="data[indextr].questions">
                <div class="d-flex align-items-center">
                  <h5 class="mb-0 font-12">
                    {{
                      data[indextr].questions.length != 0
                        ? data[indextr].questions[0].question
                        : $t("Forms.RDV.NoQuestion")
                    }}
                  </h5>
                </div>
              </vs-td>

              <vs-td>
                <div class="btn-alignment">
                  <vs-button
                    id="edit-service-button"
                    radius
                    color="primary"
                    type="border"
                    icon="visibility"
                    @click="showForm(data[indextr])"
                  ></vs-button>
                </div>
              </vs-td>
            </vs-tr>
          </template>
        </vs-table>
      </vs-card>

      <!-- Add MonRDV form -->
      <vs-prompt
        color="primary"
        @accept="createInvestigation"
        @close="close"
        @cancel="close"
        :active.sync="activeCreateInv"
        :title="$t('Forms.RDV.CreateTitle')"
        :accept-text="$t('Forms.RDV.Create')"
        :cancel-text="$t('Forms.RDV.Cancel')"
      >
        <div v-bar class="vs-scrollable">
          <div>
            <div class="con-exemple-prompt px-4 py-3">
              <!-- step of questions -->
              <vs-select
                :label="$t('Forms.RDV.NbrSteps')"
                v-model="statusInv"
                class="w-100 mb-2"
              >
                <vs-select-item
                  :key="index"
                  :value="item.value"
                  :text="item.text"
                  v-for="(item, index) in statusArray"
                />
              </vs-select>
            </div>
          </div>
        </div>
      </vs-prompt>

      <div class="centerx con-exemple-prompt">
        <vs-prompt
          @accept="updateApproval(selected.status, selected.id)"
          color="success"
          @close="close"
          @cancel="close"
          :active.sync="activeApprovalPrompt"
          :title="$t('Forms.RDV.UpdateTitle')"
          :accept-text="$t('Forms.RDV.Update')"
          :cancel-text="$t('Forms.RDV.Cancel')"
        >
          <div class="con-exemple-prompt">
            {{
              $t("Forms.RDV.Approved.Popup")[Number(selected.status)] +
              " " +
              $t("Forms.InvistigationId") +
              selected.id +
              " ?"
            }}
          </div>
        </vs-prompt>
      </div>
    </vs-col>
  </vs-row>
</template>

<script>
import { investigationsService } from "../../_services";

export default {
  name: "Forms",
  data: () => ({
    selected: {},
    activeCreateInv: false,
    activeCreateQst: false,
    activeShowQst: false,
    activeCreateAns: false,
    selectedInv: {},
    statusQst: 0,
    questionEn: "",
    questionFr: "",
    questionAr: "",
    step: 1,
    statusArray: [
      { text: "Active", value: 1 },
      { text: "Incative", value: 0 },
    ],
    statusInv: 0,
    stepButton: 2,
    selectedKey: 0,
    bookingSettings: {},
    investigations: [],
    inputs: {},
    values: {},
    name: {
      en: "",
      fr: "",
      ar: "",
      ru: "",
    },
    type: "",
    activeApprovalPrompt: false,
  }),
  methods: {
    showForm(item) {
      localStorage.setItem("selectedInv", JSON.stringify(item));
      this.$router.push("/settings/form/" + item.id + "/show");
    },
    close() {
      this.selectedInv = {};
      this.activeCreateInv = false;
      this.activeCreateQst = false;
      this.activeShowQst = false;
      this.activeCreateAns = false;
      this.activeApprovalPrompt = false;
      this.statusQst = 0;
      this.statusInv = 0;
    },
    handleSelected(item) {
      this.selectedInv = item;
      this.activeShowQst = true;
    },
    createInvestigation() {
      let inv = new FormData();
      inv.append("status", this.statusInv);
      inv.append("_method", "POST");
      investigationsService.createInvestigation(inv).then(
        function (res) {
          this.notify(
            this.$t("Toasts.Successful"),
            this.$t("Customer.CreateCustomerPrompt.ToastSuccessMessage"),
            "success"
          );
          investigationsService
            .getAll()
            .then(
              function (res) {
                this.investigations = res.investigations;
              }.bind(this)
            )
            .finally(() => {
              this.hideLoading();
            });
        }.bind(this)
      );
    },
    updateApproval(status, id) {
      let payload = {
        status: status,
      };
      this.showLoading();
      investigationsService
        .updateStatus(id, payload)
        .then((data) => {
          this.notify(
            this.$t("Toasts.Successful"),
            this.$t("Customer.CreateCustomerPrompt.ToastSuccessMessage"),
            "success"
          );
          investigationsService
            .getAll()
            .then(
              function (res) {
                this.investigations = res.investigations;
              }.bind(this)
            )
            .finally(() => {
              this.hideLoading();
            });
        })
        .catch(
          function () {
            this.notify(
              this.$t("Toasts.Error"),
              this.$t("Customer.CreateCustomerPrompt.ToastFailMessage"),
              "danger"
            );
          }.bind(this)
        )
        .finally(function () {}.bind(this));
    },
    approvedPromptInv(status, item) {
      this.selected.id = item;
      this.selected.status = status;
      this.activeApprovalPrompt = true;
    },
    notify(title, text, type) {
      this.$vs.notify({
        color: type,
        title: title,
        text: text,
      });
    },
    showLoading() {
      this.$vs.loading({
        container: "#Forms-box",
        scale: 0.6,
      });
    },
    hideLoading() {
      this.$vs.loading.close("#Forms-box > .con-vs-loading");
    },
    updateQstPrompt(item) {
      this.selectedInv = item;
      this.activeCreateQst = true;
    },
    close() {
      this.name = "";
      this.type = "";
    },
  },
  mounted() {
    this.showLoading();
    investigationsService
      .getAll()
      .then(
        function (res) {
          this.investigations = res.investigations;
        }.bind(this)
      )
      .finally(() => {
        this.hideLoading();
      });
  },
};
</script>

<style></style>
